export function dockDistance() {
	return Math.max(480, window.innerHeight);
}

export function clamp(value: number, min = 0, max = 1) {
	return Math.min(max, Math.max(min, value));
}

export function easeOut(t: number) {
	return 1 - Math.pow(1 - t, 3);
}

/** After window load, run on an idle slice so LCP work stays light. */
export function afterLoadIdle(callback: () => void, timeout = 2000) {
	let cancelled = false;
	let stopIdle = () => {};

	const run = () => {
		if (cancelled) return;
		if (typeof window.requestIdleCallback === "function") {
			const id = window.requestIdleCallback(
				() => {
					if (!cancelled) callback();
				},
				{ timeout },
			);
			stopIdle = () => window.cancelIdleCallback(id);
			return;
		}
		const id = window.setTimeout(callback, Math.min(timeout, 400));
		stopIdle = () => window.clearTimeout(id);
	};

	if (document.readyState === "complete") {
		run();
	} else {
		window.addEventListener("load", run, { once: true });
	}

	return () => {
		cancelled = true;
		window.removeEventListener("load", run);
		stopIdle();
	};
}
